import { api } from './client';

export const OnboardingAPI = {
  progress: () => api.get('/onboarding/progress'),
};
